import { ContentCollectionGroupFragment } from '../graphql/fragments/generated/contentCollectionGroup';
import { useContentCollectionGroupQuery } from '../graphql/queries/generated/contentCollectionGroup';

export default function useContentCollectionGroup({
  groupId,
  pause,
}: {
  groupId: string;
  pause?: boolean;
}) {
  const [{ data, fetching, error }] = useContentCollectionGroupQuery({
    variables: {
      filters: {
        id: groupId,
      },
    },
    pause: !groupId || pause,
  });

  return {
    group: data?.group as ContentCollectionGroupFragment | undefined,
    fetching,
    error,
  };
}
